import React from 'react'
import {isAuthMode} from 'src/shared/config'

import {useIsMobile} from '../../../hooks'
import {ModalDesktopAuth} from './ModalDesktopAuth'
import {ModalMobile} from './ModalMobile'
import {ModalMobileAuth} from './ModalMobileAuth'
import type {TimelineDetailsModalProps} from './types'

export const TimelineDetailsModal: React.FC<TimelineDetailsModalProps> = props => {
  const isMobile = useIsMobile()

  if (isAuthMode) {
    const Modal = isMobile ? ModalMobileAuth : ModalDesktopAuth
    return <Modal {...props} />
  }

  return <ModalMobile {...props} />
}
